import { render, staticRenderFns } from "./ScanRFIDButton.vue?vue&type=template&id=37cde87a&scoped=true"
import script from "./ScanRFIDButton.vue?vue&type=script&lang=js"
export * from "./ScanRFIDButton.vue?vue&type=script&lang=js"
import style0 from "./ScanRFIDButton.vue?vue&type=style&index=0&id=37cde87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cde87a",
  null
  
)

export default component.exports